import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SatisfacaoService {
    private urlModulo = `${environment.urlAPI}/pesquisasatisfacao`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista de perguntas de satisfação
     */
    public getListaSatisfacao(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.perguntas);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista de respostas de satisfação
     * @param codWorkflow Código do workflow
     */
    public getListaSatisfacaoResposta(codWorkflow: number): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-listaResposta`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.perguntas);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista de respostas de satisfação da secretaria
     * @param codWorkflow Código do workflow
     */
    public getListaSatisfacaoRespostaSecretaria(codWorkflow: number): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-listaRespostaSecretaria`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.perguntas);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Deleta Pergunta de Pesquisa de satisfação
     * @param codigo ID do item satisfação para remover
     */
    public deleteSatisfacao(codigo: number): Promise<any> {
        const payload = {
            codigo: codigo
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-delete`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Salva o item Satisfacao
     * @param obj Dados do item Satisfacao
     */
    public salvaSatisfacao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvar`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Salva as Respostas de Satisfação
     * @param obj Dados das respostas
     */
    public salvaRespostas(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarRespostas`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza o campo codWorkflow da Insatisfação
     * para pegar as respostas com o código correto
     * @param obj Dados da atualização
     */
    public updateWorkflowInsatisfacao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-updateworkflow`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/satisfacao.service.ts